/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AgreementItem } from '../models/agreement-item';
import { AgreementListResponse } from '../models/agreement-list-response';
import { agreementsControllerAddCustomerOrderEmailConfiguration } from '../fn/agreements/agreements-controller-add-customer-order-email-configuration';
import { AgreementsControllerAddCustomerOrderEmailConfiguration$Params } from '../fn/agreements/agreements-controller-add-customer-order-email-configuration';
import { agreementsControllerAddDdtEmailConfiguration } from '../fn/agreements/agreements-controller-add-ddt-email-configuration';
import { AgreementsControllerAddDdtEmailConfiguration$Params } from '../fn/agreements/agreements-controller-add-ddt-email-configuration';
import { agreementsControllerAddLogo } from '../fn/agreements/agreements-controller-add-logo';
import { AgreementsControllerAddLogo$Params } from '../fn/agreements/agreements-controller-add-logo';
import { agreementsControllerAddScheduleEmailConfiguration } from '../fn/agreements/agreements-controller-add-schedule-email-configuration';
import { AgreementsControllerAddScheduleEmailConfiguration$Params } from '../fn/agreements/agreements-controller-add-schedule-email-configuration';
import { agreementsControllerAddWarehouseLoadEmailConfiguration } from '../fn/agreements/agreements-controller-add-warehouse-load-email-configuration';
import { AgreementsControllerAddWarehouseLoadEmailConfiguration$Params } from '../fn/agreements/agreements-controller-add-warehouse-load-email-configuration';
import { agreementsControllerConnectUsers } from '../fn/agreements/agreements-controller-connect-users';
import { AgreementsControllerConnectUsers$Params } from '../fn/agreements/agreements-controller-connect-users';
import { agreementsControllerCreate } from '../fn/agreements/agreements-controller-create';
import { AgreementsControllerCreate$Params } from '../fn/agreements/agreements-controller-create';
import { agreementsControllerCreateMaintenance } from '../fn/agreements/agreements-controller-create-maintenance';
import { AgreementsControllerCreateMaintenance$Params } from '../fn/agreements/agreements-controller-create-maintenance';
import { agreementsControllerDelete } from '../fn/agreements/agreements-controller-delete';
import { AgreementsControllerDelete$Params } from '../fn/agreements/agreements-controller-delete';
import { agreementsControllerDeleteDeliveryStatusEmailConfig } from '../fn/agreements/agreements-controller-delete-delivery-status-email-config';
import { AgreementsControllerDeleteDeliveryStatusEmailConfig$Params } from '../fn/agreements/agreements-controller-delete-delivery-status-email-config';
import { agreementsControllerDeleteTicketStatusEmailConfig } from '../fn/agreements/agreements-controller-delete-ticket-status-email-config';
import { AgreementsControllerDeleteTicketStatusEmailConfig$Params } from '../fn/agreements/agreements-controller-delete-ticket-status-email-config';
import { agreementsControllerFindMaintenanceOne } from '../fn/agreements/agreements-controller-find-maintenance-one';
import { AgreementsControllerFindMaintenanceOne$Params } from '../fn/agreements/agreements-controller-find-maintenance-one';
import { agreementsControllerFindOne } from '../fn/agreements/agreements-controller-find-one';
import { AgreementsControllerFindOne$Params } from '../fn/agreements/agreements-controller-find-one';
import { agreementsControllerGetAll } from '../fn/agreements/agreements-controller-get-all';
import { AgreementsControllerGetAll$Params } from '../fn/agreements/agreements-controller-get-all';
import { agreementsControllerGetDeliveryStatusEmailConfig } from '../fn/agreements/agreements-controller-get-delivery-status-email-config';
import { AgreementsControllerGetDeliveryStatusEmailConfig$Params } from '../fn/agreements/agreements-controller-get-delivery-status-email-config';
import { agreementsControllerGetDeliveryStatusEmailConfigs } from '../fn/agreements/agreements-controller-get-delivery-status-email-configs';
import { AgreementsControllerGetDeliveryStatusEmailConfigs$Params } from '../fn/agreements/agreements-controller-get-delivery-status-email-configs';
import { agreementsControllerGetTicketStatusEmailConfig } from '../fn/agreements/agreements-controller-get-ticket-status-email-config';
import { AgreementsControllerGetTicketStatusEmailConfig$Params } from '../fn/agreements/agreements-controller-get-ticket-status-email-config';
import { agreementsControllerGetTicketStatusEmailConfigs } from '../fn/agreements/agreements-controller-get-ticket-status-email-configs';
import { AgreementsControllerGetTicketStatusEmailConfigs$Params } from '../fn/agreements/agreements-controller-get-ticket-status-email-configs';
import { agreementsControllerPreviewBodyAgreement } from '../fn/agreements/agreements-controller-preview-body-agreement';
import { AgreementsControllerPreviewBodyAgreement$Params } from '../fn/agreements/agreements-controller-preview-body-agreement';
import { agreementsControllerRecalculateSla } from '../fn/agreements/agreements-controller-recalculate-sla';
import { AgreementsControllerRecalculateSla$Params } from '../fn/agreements/agreements-controller-recalculate-sla';
import { agreementsControllerRemoveLogo } from '../fn/agreements/agreements-controller-remove-logo';
import { AgreementsControllerRemoveLogo$Params } from '../fn/agreements/agreements-controller-remove-logo';
import { agreementsControllerSendAgreementCreationEmail } from '../fn/agreements/agreements-controller-send-agreement-creation-email';
import { AgreementsControllerSendAgreementCreationEmail$Params } from '../fn/agreements/agreements-controller-send-agreement-creation-email';
import { agreementsControllerUpdate } from '../fn/agreements/agreements-controller-update';
import { AgreementsControllerUpdate$Params } from '../fn/agreements/agreements-controller-update';
import { agreementsControllerUpdateMaintenance } from '../fn/agreements/agreements-controller-update-maintenance';
import { AgreementsControllerUpdateMaintenance$Params } from '../fn/agreements/agreements-controller-update-maintenance';
import { agreementsControllerUpdateStatusEmailFlags } from '../fn/agreements/agreements-controller-update-status-email-flags';
import { AgreementsControllerUpdateStatusEmailFlags$Params } from '../fn/agreements/agreements-controller-update-status-email-flags';
import { agreementsControllerUpsertDeliveryStatusEmailConfig } from '../fn/agreements/agreements-controller-upsert-delivery-status-email-config';
import { AgreementsControllerUpsertDeliveryStatusEmailConfig$Params } from '../fn/agreements/agreements-controller-upsert-delivery-status-email-config';
import { agreementsControllerUpsertTicketStatusEmailConfig } from '../fn/agreements/agreements-controller-upsert-ticket-status-email-config';
import { AgreementsControllerUpsertTicketStatusEmailConfig$Params } from '../fn/agreements/agreements-controller-upsert-ticket-status-email-config';
import { BaseResponse } from '../models/base-response';
import { EmptyResponse } from '../models/empty-response';

@Injectable({ providedIn: 'root' })
export class AgreementsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `agreementsControllerGetAll()` */
  static readonly AgreementsControllerGetAllPath = '/agreements';

  /**
   * Restituisce l'elenco degli agreement.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `agreementsControllerGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  agreementsControllerGetAll$Response(params: AgreementsControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AgreementListResponse;
}>> {
    return agreementsControllerGetAll(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco degli agreement.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `agreementsControllerGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  agreementsControllerGetAll(params: AgreementsControllerGetAll$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AgreementListResponse;
}> {
    return this.agreementsControllerGetAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AgreementListResponse;
}>): BaseResponse & {
'data'?: AgreementListResponse;
} => r.body)
    );
  }

  /** Path part for operation `agreementsControllerCreate()` */
  static readonly AgreementsControllerCreatePath = '/agreements';

  /**
   * Crea un agreement.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `agreementsControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  agreementsControllerCreate$Response(params: AgreementsControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AgreementItem;
}>> {
    return agreementsControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea un agreement.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `agreementsControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  agreementsControllerCreate(params: AgreementsControllerCreate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AgreementItem;
}> {
    return this.agreementsControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AgreementItem;
}>): BaseResponse & {
'data'?: AgreementItem;
} => r.body)
    );
  }

  /** Path part for operation `agreementsControllerAddDdtEmailConfiguration()` */
  static readonly AgreementsControllerAddDdtEmailConfigurationPath = '/agreements/{id}/email-configuration/ddt';

  /**
   * Aggiunge una configurazione email per l'invio delle email alla creazione di un DDT.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `agreementsControllerAddDdtEmailConfiguration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  agreementsControllerAddDdtEmailConfiguration$Response(params: AgreementsControllerAddDdtEmailConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AgreementItem;
}>> {
    return agreementsControllerAddDdtEmailConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Aggiunge una configurazione email per l'invio delle email alla creazione di un DDT.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `agreementsControllerAddDdtEmailConfiguration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  agreementsControllerAddDdtEmailConfiguration(params: AgreementsControllerAddDdtEmailConfiguration$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AgreementItem;
}> {
    return this.agreementsControllerAddDdtEmailConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AgreementItem;
}>): BaseResponse & {
'data'?: AgreementItem;
} => r.body)
    );
  }

  /** Path part for operation `agreementsControllerAddCustomerOrderEmailConfiguration()` */
  static readonly AgreementsControllerAddCustomerOrderEmailConfigurationPath = '/agreements/{id}/email-configuration/customer-order';

  /**
   * Aggiunge una configurazione email per l'invio delle email alla creazione di un ordine del cliente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `agreementsControllerAddCustomerOrderEmailConfiguration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  agreementsControllerAddCustomerOrderEmailConfiguration$Response(params: AgreementsControllerAddCustomerOrderEmailConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AgreementItem;
}>> {
    return agreementsControllerAddCustomerOrderEmailConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Aggiunge una configurazione email per l'invio delle email alla creazione di un ordine del cliente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `agreementsControllerAddCustomerOrderEmailConfiguration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  agreementsControllerAddCustomerOrderEmailConfiguration(params: AgreementsControllerAddCustomerOrderEmailConfiguration$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AgreementItem;
}> {
    return this.agreementsControllerAddCustomerOrderEmailConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AgreementItem;
}>): BaseResponse & {
'data'?: AgreementItem;
} => r.body)
    );
  }

  /** Path part for operation `agreementsControllerAddWarehouseLoadEmailConfiguration()` */
  static readonly AgreementsControllerAddWarehouseLoadEmailConfigurationPath = '/agreements/{id}/email-configuration/warehouse-load';

  /**
   * Aggiunge una configurazione email per l'invio delle email alla creazione di un carico magazzino.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `agreementsControllerAddWarehouseLoadEmailConfiguration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  agreementsControllerAddWarehouseLoadEmailConfiguration$Response(params: AgreementsControllerAddWarehouseLoadEmailConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AgreementItem;
}>> {
    return agreementsControllerAddWarehouseLoadEmailConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Aggiunge una configurazione email per l'invio delle email alla creazione di un carico magazzino.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `agreementsControllerAddWarehouseLoadEmailConfiguration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  agreementsControllerAddWarehouseLoadEmailConfiguration(params: AgreementsControllerAddWarehouseLoadEmailConfiguration$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AgreementItem;
}> {
    return this.agreementsControllerAddWarehouseLoadEmailConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AgreementItem;
}>): BaseResponse & {
'data'?: AgreementItem;
} => r.body)
    );
  }

  /** Path part for operation `agreementsControllerAddScheduleEmailConfiguration()` */
  static readonly AgreementsControllerAddScheduleEmailConfigurationPath = '/agreements/{id}/email-configuration/schedule';

  /**
   * Aggiunge una configurazione email per l'invio delle email alla creazione di una schedulazione.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `agreementsControllerAddScheduleEmailConfiguration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  agreementsControllerAddScheduleEmailConfiguration$Response(params: AgreementsControllerAddScheduleEmailConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AgreementItem;
}>> {
    return agreementsControllerAddScheduleEmailConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Aggiunge una configurazione email per l'invio delle email alla creazione di una schedulazione.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `agreementsControllerAddScheduleEmailConfiguration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  agreementsControllerAddScheduleEmailConfiguration(params: AgreementsControllerAddScheduleEmailConfiguration$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AgreementItem;
}> {
    return this.agreementsControllerAddScheduleEmailConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AgreementItem;
}>): BaseResponse & {
'data'?: AgreementItem;
} => r.body)
    );
  }

  /** Path part for operation `agreementsControllerAddLogo()` */
  static readonly AgreementsControllerAddLogoPath = '/agreements/{id}/logo';

  /**
   * Logo della commessa.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `agreementsControllerAddLogo()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  agreementsControllerAddLogo$Response(params: AgreementsControllerAddLogo$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AgreementItem;
}>> {
    return agreementsControllerAddLogo(this.http, this.rootUrl, params, context);
  }

  /**
   * Logo della commessa.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `agreementsControllerAddLogo$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  agreementsControllerAddLogo(params: AgreementsControllerAddLogo$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AgreementItem;
}> {
    return this.agreementsControllerAddLogo$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AgreementItem;
}>): BaseResponse & {
'data'?: AgreementItem;
} => r.body)
    );
  }

  /** Path part for operation `agreementsControllerRemoveLogo()` */
  static readonly AgreementsControllerRemoveLogoPath = '/agreements/{id}/logo';

  /**
   * Elimina il logo di un agreement.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `agreementsControllerRemoveLogo()` instead.
   *
   * This method doesn't expect any request body.
   */
  agreementsControllerRemoveLogo$Response(params: AgreementsControllerRemoveLogo$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AgreementItem;
}>> {
    return agreementsControllerRemoveLogo(this.http, this.rootUrl, params, context);
  }

  /**
   * Elimina il logo di un agreement.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `agreementsControllerRemoveLogo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  agreementsControllerRemoveLogo(params: AgreementsControllerRemoveLogo$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AgreementItem;
}> {
    return this.agreementsControllerRemoveLogo$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AgreementItem;
}>): BaseResponse & {
'data'?: AgreementItem;
} => r.body)
    );
  }

  /** Path part for operation `agreementsControllerFindOne()` */
  static readonly AgreementsControllerFindOnePath = '/agreements/{id}';

  /**
   * Restituisce un agreement.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `agreementsControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  agreementsControllerFindOne$Response(params: AgreementsControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AgreementItem;
}>> {
    return agreementsControllerFindOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce un agreement.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `agreementsControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  agreementsControllerFindOne(params: AgreementsControllerFindOne$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AgreementItem;
}> {
    return this.agreementsControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AgreementItem;
}>): BaseResponse & {
'data'?: AgreementItem;
} => r.body)
    );
  }

  /** Path part for operation `agreementsControllerDelete()` */
  static readonly AgreementsControllerDeletePath = '/agreements/{id}';

  /**
   * Elimina un agreement.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `agreementsControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  agreementsControllerDelete$Response(params: AgreementsControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AgreementItem;
}>> {
    return agreementsControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Elimina un agreement.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `agreementsControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  agreementsControllerDelete(params: AgreementsControllerDelete$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AgreementItem;
}> {
    return this.agreementsControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AgreementItem;
}>): BaseResponse & {
'data'?: AgreementItem;
} => r.body)
    );
  }

  /** Path part for operation `agreementsControllerUpdate()` */
  static readonly AgreementsControllerUpdatePath = '/agreements/{id}';

  /**
   * Modifica un agreement.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `agreementsControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  agreementsControllerUpdate$Response(params: AgreementsControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AgreementItem;
}>> {
    return agreementsControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Modifica un agreement.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `agreementsControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  agreementsControllerUpdate(params: AgreementsControllerUpdate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AgreementItem;
}> {
    return this.agreementsControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AgreementItem;
}>): BaseResponse & {
'data'?: AgreementItem;
} => r.body)
    );
  }

  /** Path part for operation `agreementsControllerRecalculateSla()` */
  static readonly AgreementsControllerRecalculateSlaPath = '/agreements/{id}/recalculate-sla';

  /**
   * Ricalcola in background lo SLA di tutti i ticket e le consegne collegati alla commessa, in base allo SLA attualmente impostato sulla commessa. Può richiedere diversi minuti: l'operazione viene avviata e la risposta torna subito, senza attenderne il completamento.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `agreementsControllerRecalculateSla()` instead.
   *
   * This method doesn't expect any request body.
   */
  agreementsControllerRecalculateSla$Response(params: AgreementsControllerRecalculateSla$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>> {
    return agreementsControllerRecalculateSla(this.http, this.rootUrl, params, context);
  }

  /**
   * Ricalcola in background lo SLA di tutti i ticket e le consegne collegati alla commessa, in base allo SLA attualmente impostato sulla commessa. Può richiedere diversi minuti: l'operazione viene avviata e la risposta torna subito, senza attenderne il completamento.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `agreementsControllerRecalculateSla$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  agreementsControllerRecalculateSla(params: AgreementsControllerRecalculateSla$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: EmptyResponse;
}> {
    return this.agreementsControllerRecalculateSla$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>): BaseResponse & {
'data'?: EmptyResponse;
} => r.body)
    );
  }

  /** Path part for operation `agreementsControllerCreateMaintenance()` */
  static readonly AgreementsControllerCreateMaintenancePath = '/agreements/maintenance';

  /**
   * Crea un agreement di tipo manutenzione.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `agreementsControllerCreateMaintenance()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  agreementsControllerCreateMaintenance$Response(params: AgreementsControllerCreateMaintenance$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AgreementItem;
}>> {
    return agreementsControllerCreateMaintenance(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea un agreement di tipo manutenzione.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `agreementsControllerCreateMaintenance$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  agreementsControllerCreateMaintenance(params: AgreementsControllerCreateMaintenance$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AgreementItem;
}> {
    return this.agreementsControllerCreateMaintenance$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AgreementItem;
}>): BaseResponse & {
'data'?: AgreementItem;
} => r.body)
    );
  }

  /** Path part for operation `agreementsControllerFindMaintenanceOne()` */
  static readonly AgreementsControllerFindMaintenanceOnePath = '/agreements/maintenance/{id}';

  /**
   * Restituisce un maintenance agreement.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `agreementsControllerFindMaintenanceOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  agreementsControllerFindMaintenanceOne$Response(params: AgreementsControllerFindMaintenanceOne$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AgreementItem;
}>> {
    return agreementsControllerFindMaintenanceOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce un maintenance agreement.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `agreementsControllerFindMaintenanceOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  agreementsControllerFindMaintenanceOne(params: AgreementsControllerFindMaintenanceOne$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AgreementItem;
}> {
    return this.agreementsControllerFindMaintenanceOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AgreementItem;
}>): BaseResponse & {
'data'?: AgreementItem;
} => r.body)
    );
  }

  /** Path part for operation `agreementsControllerUpdateMaintenance()` */
  static readonly AgreementsControllerUpdateMaintenancePath = '/agreements/maintenance/{id}';

  /**
   * Modifica un agreement di tipo manutenzione.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `agreementsControllerUpdateMaintenance()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  agreementsControllerUpdateMaintenance$Response(params: AgreementsControllerUpdateMaintenance$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AgreementItem;
}>> {
    return agreementsControllerUpdateMaintenance(this.http, this.rootUrl, params, context);
  }

  /**
   * Modifica un agreement di tipo manutenzione.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `agreementsControllerUpdateMaintenance$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  agreementsControllerUpdateMaintenance(params: AgreementsControllerUpdateMaintenance$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AgreementItem;
}> {
    return this.agreementsControllerUpdateMaintenance$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AgreementItem;
}>): BaseResponse & {
'data'?: AgreementItem;
} => r.body)
    );
  }

  /** Path part for operation `agreementsControllerUpdateStatusEmailFlags()` */
  static readonly AgreementsControllerUpdateStatusEmailFlagsPath = '/agreements/{id}/status-email-flags';

  /**
   * Aggiorna i flag di disabilitazione email stati ticket/consegna.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `agreementsControllerUpdateStatusEmailFlags()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  agreementsControllerUpdateStatusEmailFlags$Response(params: AgreementsControllerUpdateStatusEmailFlags$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return agreementsControllerUpdateStatusEmailFlags(this.http, this.rootUrl, params, context);
  }

  /**
   * Aggiorna i flag di disabilitazione email stati ticket/consegna.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `agreementsControllerUpdateStatusEmailFlags$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  agreementsControllerUpdateStatusEmailFlags(params: AgreementsControllerUpdateStatusEmailFlags$Params, context?: HttpContext): Observable<void> {
    return this.agreementsControllerUpdateStatusEmailFlags$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `agreementsControllerGetTicketStatusEmailConfig()` */
  static readonly AgreementsControllerGetTicketStatusEmailConfigPath = '/agreements/{id}/ticket-status-email-configs/{ticket_status_id}';

  /**
   * Recupera configurazione email di uno stato ticket per commessa.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `agreementsControllerGetTicketStatusEmailConfig()` instead.
   *
   * This method doesn't expect any request body.
   */
  agreementsControllerGetTicketStatusEmailConfig$Response(params: AgreementsControllerGetTicketStatusEmailConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return agreementsControllerGetTicketStatusEmailConfig(this.http, this.rootUrl, params, context);
  }

  /**
   * Recupera configurazione email di uno stato ticket per commessa.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `agreementsControllerGetTicketStatusEmailConfig$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  agreementsControllerGetTicketStatusEmailConfig(params: AgreementsControllerGetTicketStatusEmailConfig$Params, context?: HttpContext): Observable<void> {
    return this.agreementsControllerGetTicketStatusEmailConfig$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `agreementsControllerUpsertTicketStatusEmailConfig()` */
  static readonly AgreementsControllerUpsertTicketStatusEmailConfigPath = '/agreements/{id}/ticket-status-email-configs/{ticket_status_id}';

  /**
   * Imposta override configurazione email stato ticket per commessa.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `agreementsControllerUpsertTicketStatusEmailConfig()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  agreementsControllerUpsertTicketStatusEmailConfig$Response(params: AgreementsControllerUpsertTicketStatusEmailConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return agreementsControllerUpsertTicketStatusEmailConfig(this.http, this.rootUrl, params, context);
  }

  /**
   * Imposta override configurazione email stato ticket per commessa.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `agreementsControllerUpsertTicketStatusEmailConfig$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  agreementsControllerUpsertTicketStatusEmailConfig(params: AgreementsControllerUpsertTicketStatusEmailConfig$Params, context?: HttpContext): Observable<void> {
    return this.agreementsControllerUpsertTicketStatusEmailConfig$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `agreementsControllerDeleteTicketStatusEmailConfig()` */
  static readonly AgreementsControllerDeleteTicketStatusEmailConfigPath = '/agreements/{id}/ticket-status-email-configs/{ticket_status_id}';

  /**
   * Rimuove override configurazione email stato ticket per commessa.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `agreementsControllerDeleteTicketStatusEmailConfig()` instead.
   *
   * This method doesn't expect any request body.
   */
  agreementsControllerDeleteTicketStatusEmailConfig$Response(params: AgreementsControllerDeleteTicketStatusEmailConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return agreementsControllerDeleteTicketStatusEmailConfig(this.http, this.rootUrl, params, context);
  }

  /**
   * Rimuove override configurazione email stato ticket per commessa.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `agreementsControllerDeleteTicketStatusEmailConfig$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  agreementsControllerDeleteTicketStatusEmailConfig(params: AgreementsControllerDeleteTicketStatusEmailConfig$Params, context?: HttpContext): Observable<void> {
    return this.agreementsControllerDeleteTicketStatusEmailConfig$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `agreementsControllerGetTicketStatusEmailConfigs()` */
  static readonly AgreementsControllerGetTicketStatusEmailConfigsPath = '/agreements/{id}/ticket-status-email-configs';

  /**
   * Lista configurazioni email stati ticket per commessa.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `agreementsControllerGetTicketStatusEmailConfigs()` instead.
   *
   * This method doesn't expect any request body.
   */
  agreementsControllerGetTicketStatusEmailConfigs$Response(params: AgreementsControllerGetTicketStatusEmailConfigs$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return agreementsControllerGetTicketStatusEmailConfigs(this.http, this.rootUrl, params, context);
  }

  /**
   * Lista configurazioni email stati ticket per commessa.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `agreementsControllerGetTicketStatusEmailConfigs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  agreementsControllerGetTicketStatusEmailConfigs(params: AgreementsControllerGetTicketStatusEmailConfigs$Params, context?: HttpContext): Observable<void> {
    return this.agreementsControllerGetTicketStatusEmailConfigs$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `agreementsControllerGetDeliveryStatusEmailConfig()` */
  static readonly AgreementsControllerGetDeliveryStatusEmailConfigPath = '/agreements/{id}/delivery-status-email-configs/{delivery_status_id}';

  /**
   * Recupera configurazione email di uno stato consegna per commessa.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `agreementsControllerGetDeliveryStatusEmailConfig()` instead.
   *
   * This method doesn't expect any request body.
   */
  agreementsControllerGetDeliveryStatusEmailConfig$Response(params: AgreementsControllerGetDeliveryStatusEmailConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return agreementsControllerGetDeliveryStatusEmailConfig(this.http, this.rootUrl, params, context);
  }

  /**
   * Recupera configurazione email di uno stato consegna per commessa.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `agreementsControllerGetDeliveryStatusEmailConfig$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  agreementsControllerGetDeliveryStatusEmailConfig(params: AgreementsControllerGetDeliveryStatusEmailConfig$Params, context?: HttpContext): Observable<void> {
    return this.agreementsControllerGetDeliveryStatusEmailConfig$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `agreementsControllerUpsertDeliveryStatusEmailConfig()` */
  static readonly AgreementsControllerUpsertDeliveryStatusEmailConfigPath = '/agreements/{id}/delivery-status-email-configs/{delivery_status_id}';

  /**
   * Imposta override configurazione email stato consegna per commessa.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `agreementsControllerUpsertDeliveryStatusEmailConfig()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  agreementsControllerUpsertDeliveryStatusEmailConfig$Response(params: AgreementsControllerUpsertDeliveryStatusEmailConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return agreementsControllerUpsertDeliveryStatusEmailConfig(this.http, this.rootUrl, params, context);
  }

  /**
   * Imposta override configurazione email stato consegna per commessa.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `agreementsControllerUpsertDeliveryStatusEmailConfig$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  agreementsControllerUpsertDeliveryStatusEmailConfig(params: AgreementsControllerUpsertDeliveryStatusEmailConfig$Params, context?: HttpContext): Observable<void> {
    return this.agreementsControllerUpsertDeliveryStatusEmailConfig$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `agreementsControllerDeleteDeliveryStatusEmailConfig()` */
  static readonly AgreementsControllerDeleteDeliveryStatusEmailConfigPath = '/agreements/{id}/delivery-status-email-configs/{delivery_status_id}';

  /**
   * Rimuove override configurazione email stato consegna per commessa.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `agreementsControllerDeleteDeliveryStatusEmailConfig()` instead.
   *
   * This method doesn't expect any request body.
   */
  agreementsControllerDeleteDeliveryStatusEmailConfig$Response(params: AgreementsControllerDeleteDeliveryStatusEmailConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return agreementsControllerDeleteDeliveryStatusEmailConfig(this.http, this.rootUrl, params, context);
  }

  /**
   * Rimuove override configurazione email stato consegna per commessa.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `agreementsControllerDeleteDeliveryStatusEmailConfig$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  agreementsControllerDeleteDeliveryStatusEmailConfig(params: AgreementsControllerDeleteDeliveryStatusEmailConfig$Params, context?: HttpContext): Observable<void> {
    return this.agreementsControllerDeleteDeliveryStatusEmailConfig$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `agreementsControllerGetDeliveryStatusEmailConfigs()` */
  static readonly AgreementsControllerGetDeliveryStatusEmailConfigsPath = '/agreements/{id}/delivery-status-email-configs';

  /**
   * Lista configurazioni email stati consegna per commessa.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `agreementsControllerGetDeliveryStatusEmailConfigs()` instead.
   *
   * This method doesn't expect any request body.
   */
  agreementsControllerGetDeliveryStatusEmailConfigs$Response(params: AgreementsControllerGetDeliveryStatusEmailConfigs$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return agreementsControllerGetDeliveryStatusEmailConfigs(this.http, this.rootUrl, params, context);
  }

  /**
   * Lista configurazioni email stati consegna per commessa.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `agreementsControllerGetDeliveryStatusEmailConfigs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  agreementsControllerGetDeliveryStatusEmailConfigs(params: AgreementsControllerGetDeliveryStatusEmailConfigs$Params, context?: HttpContext): Observable<void> {
    return this.agreementsControllerGetDeliveryStatusEmailConfigs$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `agreementsControllerConnectUsers()` */
  static readonly AgreementsControllerConnectUsersPath = '/agreements/{agreement_id}/users';

  /**
   * Connette gli utenti ad una agreement.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `agreementsControllerConnectUsers()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  agreementsControllerConnectUsers$Response(params: AgreementsControllerConnectUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>> {
    return agreementsControllerConnectUsers(this.http, this.rootUrl, params, context);
  }

  /**
   * Connette gli utenti ad una agreement.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `agreementsControllerConnectUsers$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  agreementsControllerConnectUsers(params: AgreementsControllerConnectUsers$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: EmptyResponse;
}> {
    return this.agreementsControllerConnectUsers$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>): BaseResponse & {
'data'?: EmptyResponse;
} => r.body)
    );
  }

  /** Path part for operation `agreementsControllerPreviewBodyAgreement()` */
  static readonly AgreementsControllerPreviewBodyAgreementPath = '/agreements/{id}/preview-body-creation';

  /**
   * Restituisce l'anteprima dell'email di apertura commessa con le variabili sostituite.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `agreementsControllerPreviewBodyAgreement()` instead.
   *
   * This method doesn't expect any request body.
   */
  agreementsControllerPreviewBodyAgreement$Response(params: AgreementsControllerPreviewBodyAgreement$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>> {
    return agreementsControllerPreviewBodyAgreement(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'anteprima dell'email di apertura commessa con le variabili sostituite.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `agreementsControllerPreviewBodyAgreement$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  agreementsControllerPreviewBodyAgreement(params: AgreementsControllerPreviewBodyAgreement$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: EmptyResponse;
}> {
    return this.agreementsControllerPreviewBodyAgreement$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>): BaseResponse & {
'data'?: EmptyResponse;
} => r.body)
    );
  }

  /** Path part for operation `agreementsControllerSendAgreementCreationEmail()` */
  static readonly AgreementsControllerSendAgreementCreationEmailPath = '/agreements/{id}/send-creation-email';

  /**
   * Invia l'email di apertura commessa.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `agreementsControllerSendAgreementCreationEmail()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  agreementsControllerSendAgreementCreationEmail$Response(params: AgreementsControllerSendAgreementCreationEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>> {
    return agreementsControllerSendAgreementCreationEmail(this.http, this.rootUrl, params, context);
  }

  /**
   * Invia l'email di apertura commessa.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `agreementsControllerSendAgreementCreationEmail$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  agreementsControllerSendAgreementCreationEmail(params: AgreementsControllerSendAgreementCreationEmail$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: EmptyResponse;
}> {
    return this.agreementsControllerSendAgreementCreationEmail$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>): BaseResponse & {
'data'?: EmptyResponse;
} => r.body)
    );
  }

}
